import HttpRequest from '@/plugins/axios'

class ConfigProvider extends HttpRequest {
  constructor() {
    super(process.env.VUE_APP_API_URL)
  }

  //===========================================================================
  //ConfigYear
  async getYears() {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'CONFIG_CURRENT_YEAR',
      order: [JSON.stringify({
        ADMIT_YEAR: 'DESC',
        ADMIT_SEMESTER: 'DESC',
      })]
    })
    return data
  }
  async setYear({ level_id, admit_year, admit_semester, start_datetime_system, admit_date }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'CONFIG_CURRENT_YEAR',
      set: [JSON.stringify({
        LEVEL_ID: level_id,
        ADMIT_YEAR: admit_year,
        ADMIT_SEMESTER: admit_semester,
        START_DATETIME_SYSTEM: start_datetime_system,
        ADMIT_DATE: admit_date,
      })]
    })
    return data
  }
  async deleteYear({ year_id }) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'CONFIG_CURRENT_YEAR',
      where: [JSON.stringify({
        YEAR_ID: year_id,
      })]
    })
    return data
  }

  // ConfigRound
  async getRounds() {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'CONFIG_ROUND',
      order: [JSON.stringify({
        START_DATETIME: 'DESC',
      })]
    })
    return data
  }
  async setRound({ round_id, round_name_th, round_name_en, year_id, round_start_datetime, round_end_datetime }) {
    const { data } = await this.create('/', {
      function: 'set-config',
      table: 'CONFIG_ROUND',
      set: [JSON.stringify({
        ROUND_ID: round_id,
        ROUND_NAME_TH: round_name_th,
        ROUND_NAME_EN: round_name_en,
        YEAR_ID: year_id,
        START_DATETIME: round_start_datetime,
        END_DATETIME: round_end_datetime,
      })]
    })
    return data
  }
  async deleteRound({ id }) {
    const { data } = await this.delete('/', {
      function: 'delete-config',
      table: 'CONFIG_ROUND',
      where: [JSON.stringify({
        ROUND_ID: id,
      })]
    })
    return data
  }

  //ConfigDocument
  async getDocuments() {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'CONFIG_DOCUMENT_TYPE',
    })
    return data
  }

  async getYearByLevelIds(level_id) {
    const { data } = await this.get('/', {
      function: 'get-config',
      table: 'CONFIG_CURRENT_YEAR',
      where: [JSON.stringify({
        LEVEL_ID: level_id == 1 ? 1 : 2
      })],
      order: [JSON.stringify({
        ADMIT_YEAR: 'DESC',
        ADMIT_SEMESTER: 'DESC',
      })]
    })
    return data
  }
}
export default ConfigProvider